var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"bounce"}},[(_vm.show)?_c('div',{staticClass:"popupmsg",style:(_vm.positionStyling)},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_c('span',[_vm._v(_vm._s(_vm.msg))]),_c('div',{attrs:{"id":"triangle"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }